import type { CSSProperties, ReactNode, SVGProps } from 'react';

export type ToolIconProps = Omit<
  SVGProps<SVGSVGElement>,
  'color' | 'children'
> & {
  size?: number | string;
  title?: string;
  /** Stroke/fill color. Default follows the selected theme. */
  primary?: string;
  /** Accent color. Default is the panel green swatch. */
  secondary?: string;
  /**
   * `false` uses the surrounding text color.
   * `true` or omitted keeps the two theme colors.
   */
  active?: boolean;
};

export const toolIconPrimary = 'var(--icon-primary, var(--brand-accent, #00a59c))';
export const toolIconSecondary =
  'var(--icon-secondary, var(--brand-secondary, #a69274))';

const themePrimary =
  'var(--falcon-navbar-vertical-default-link-active-color, var(--falcon-primary, #00a59c))';

/** رنگ «سبز آبی» در انتخاب رنگ پنل. */
const themeGreen = '#02928b';

export function ToolIconFrame({
  size = '22px',
  className,
  title,
  primary,
  secondary,
  active,
  children,
  style,
  ...rest
}: ToolIconProps & { children: ReactNode }) {
  const themeStyle = {
    '--icon-primary': primary ?? (active === false ? 'currentColor' : themePrimary),
    '--icon-secondary': secondary ?? (active === false ? 'currentColor' : themeGreen),
    display: 'block',
    flexShrink: 0,
    overflow: 'visible',
    shapeRendering: 'geometricPrecision'
  } as CSSProperties;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      width={size}
      height={size}
      fill="none"
      className={['tool-icon', className].filter(Boolean).join(' ')}
      role={title ? 'img' : 'presentation'}
      aria-hidden={title ? undefined : true}
      style={{ ...themeStyle, ...style }}
      {...rest}
    >
      {title ? <title>{title}</title> : null}
      {children}
    </svg>
  );
}
